module.exports = __webpack_public_path__ + "img/title-1-c3fb88.png";